/*
 * @Descripttion:
 * @Author: Solarains
 * @Date: 2022-04-17 18:46:27
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dateType: 2, // 1: 日 2：月 3：年
    clientHeight: 1080,
    clientWidth: 1920,
  },
  getters: {
  },
  mutations: {
    changeDateType(state, typeNum) {
      state.dateType = typeNum;
    },
    // 设置窗口可见区域高度
    setClientHeight(state, height) {
      state.clientHeight = height;
      console.log("当前窗口可见区域宽度：",height)
    },
    // 设置窗口可见区域宽度
    setClientWidth(state, width) {
      state.clientWidth = width;
      console.log("当前窗口可见区域宽度：",width)
    },
  },
  actions: {},
  modules: {},
});
